import api from "../service/api";

// Identificador do tenant = primeiro rótulo do subdomínio.
// Ex.: "futuagro.formsdigital.com.br" -> "futuagro".
function getTenant() {
  return window.location.hostname.split(".")[0];
}

// Traduz o subdomínio -> id da empresa via /getDomain (envelope: data.result.id).
// Padrão canônico usado em Usuario/index.jsx, DialogForm.jsx, AddDialogForm.jsx, etc.
async function resolveEnterpriseId() {
  const resp = await api.get(`/getDomain?domain=${getTenant()}`);
  return resp.data.data.result.id;
}

export { getTenant, resolveEnterpriseId };
